import { IconButton, Stack, Typography } from '@mui/material';

import { PageEventFragment } from 'types/api/dato-operations.types';

import FormattedDateTime from 'components/@events/FormattedDateTime';
import Icon from 'components/@icons/Icon';
import SeatsTimer from 'components/@seating/SeatsTimer';

interface Props {
  event: PageEventFragment;
  endTime: string | undefined;
  onCloseDialog: () => void;
}

const Header = ({ event, endTime, onCloseDialog }: Props) => {
  return (
    <Stack
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        mt: { xs: 2, md: 3 },
      }}
    >
      <Stack
        sx={{
          gap: 0.5,
          alignSelf: 'flex-start',
        }}
      >
        <Typography variant="h7" component="h1">
          {event.title}
        </Typography>

        <FormattedDateTime
          endDatetime={event.endDatetime}
          startDatetime={event.startDatetime}
          timezone={event.timezone}
        />
      </Stack>
      <Stack
        sx={{
          gap: 1,
          flexDirection: 'row',
        }}
      >
        <SeatsTimer endTime={endTime} />
        <IconButton size="small" onClick={onCloseDialog}>
          <Icon name="Close" />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default Header;
